export default function ajaxLoader() {
	$(document).on('berocket_ajax_products_loaded', function () {
		$(document).trigger('yith_wcwl_init');
	});
}
